/**
 * Shared PostgREST filters for worker-facing cleaning_tasks queries.
 * Cancelled (soft-deleted) extra/coordinator tasks must stay off the work list
 * and out of section counters — otherwise the employee UI and owner counters diverge.
 */

export function cleanerActiveTasksOrFilter(
  todayStartISO: string,
  todayEndISO: string,
): string {
  return [
    "status.in.(pending,in_progress)",
    `and(status.eq.done,or(completed_at.gte.${todayStartISO},completed_at.is.null))`,
    "and(task_type.eq.coordinator_single,status.neq.done)",
    "and(task_type.eq.employee_extra,status.neq.done)",
    `and(task_type.eq.sop_standard,scheduled_at.gte.${todayStartISO},scheduled_at.lte.${todayEndISO})`,
    `and(task_type.eq.long_term,scheduled_at.lte.${todayEndISO},status.neq.done)`,
  ].join(",");
}

export function isCancelledCleaningTask(
  status: string | null | undefined,
): boolean {
  return status === "cancelled";
}
